import jQuery from 'jquery'

const MIN_SCREEN_WIDTH_SM = 768

function showActions(parentElement) {
  jQuery('.expand-actions', parentElement).addClass('d-none').removeClass('d-flex')
  jQuery('.collapse-actions', parentElement).addClass('d-flex').removeClass('d-none')
  if (jQuery('.actions', parentElement).hasClass('d-none')) {
    jQuery('.actions', parentElement).css('display', 'none').removeClass('d-none')
  }
  jQuery('.actions', parentElement).slideDown()
}

function hideActions(parentElement) {
  jQuery('.actions', parentElement).slideUp('normal', () => {
    jQuery('.expand-actions', parentElement).removeClass('d-none').addClass('d-flex')
    jQuery('.collapse-actions', parentElement).addClass('d-none').removeClass('d-flex')
  })
}

jQuery(() => {
  let expander = jQuery('.collapsable-actions .expand-actions')
  expander.on('click', (evt) => {
    evt.preventDefault()
    let parentElement = evt.target.closest('.collapsable-actions')
    showActions(parentElement)
  })

  let collapser = jQuery('.collapsable-actions .collapse-actions')
  collapser.on('click', (evt) => {
    evt.preventDefault()
    let parentElement = evt.target.closest('.collapsable-actions')
    hideActions(parentElement)
  })

  const showActionsForNonXsScreen = function() {
    if (jQuery(window).width() >= MIN_SCREEN_WIDTH_SM) {
      // We're not on an xs screen, so show the actions and reset the xs-only expand/collapse controls
      jQuery('.collapsable-actions .actions').show().addClass('d-none')
      expander.addClass('d-flex')
      collapser.addClass('d-none')
    }
  }
  window.addEventListener('resize', showActionsForNonXsScreen)
  jQuery(window).on('unload', () => {
    window.removeEventListener('resize', showActionsForNonXsScreen)
  })
})
